import { i18n } from './i18n';

/**
 * Zamienia błąd żądania na komunikat DLA CZŁOWIEKA.
 *
 * Po co: axios zwraca „Request failed with status code 500" albo „Network Error",
 * a wrzucenie tego wprost do interfejsu nic użytkownikowi nie mówi i wygląda jak
 * usterka aplikacji. Rozróżniamy trzy sytuacje, w których użytkownik ROBI coś
 * innego: brak sieci (sprawdź połączenie), błąd po naszej stronie (spróbuj za
 * chwilę) i brak uprawnień (nie ma czego ponawiać).
 *
 * @param error błąd z axiosa / fetcha.
 * @param fallback komunikat, gdy nic bardziej trafnego nie da się powiedzieć.
 */
export const getRequestErrorMessage = (error: unknown, fallback?: string): string => {
  const t = i18n.t.bind(i18n);
  const err = error as {
    response?: { status?: number; data?: { message?: string } };
    code?: string;
    message?: string;
  } | undefined;

  // Komunikat z naszego backendu jest zawsze lepszy niż cokolwiek zgadniętego.
  const backendMessage = err?.response?.data?.message;
  if (backendMessage && !/^Request failed|^Network Error/i.test(backendMessage)) {
    return backendMessage;
  }

  const status = err?.response?.status;

  if (!status || err?.code === 'ERR_NETWORK' || /Network Error/i.test(err?.message ?? '')) {
    return String(t('errors.network', 'Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.'));
  }
  if (status === 401 || status === 403) {
    return String(t('errors.forbidden', 'Nie masz uprawnień do tych danych.'));
  }
  if (status === 404) {
    return String(t('errors.notFound', 'Nie znaleźliśmy tych danych.'));
  }
  if (status >= 500) {
    return String(t('errors.server', 'Usługa chwilowo niedostępna. Spróbuj ponownie za moment.'));
  }

  return fallback || String(t('errors.default', 'Coś poszło nie tak. Spróbuj ponownie.'));
};
